!function(factory){"use strict";"function"==typeof define&&define.amd?define(["jquery"],factory):"object"==typeof module&&module.exports?module.exports=factory(require("jquery")):jQuery&&!jQuery.fn.hoverIntent&&factory(jQuery)}(function($){"use strict";function track(ev){cX=ev.pageX,cY=ev.pageY}var cX,cY,_cfg={interval:100,sensitivity:6,timeout:0},INSTANCE_COUNT=0,compare=function(ev,$el,s,cfg){if(Math.sqrt((s.pX-cX)*(s.pX-cX)+(s.pY-cY)*(s.pY-cY))<cfg.sensitivity)return $el.off(s.event,track),delete s.timeoutId,s.isActive=!0,ev.pageX=cX,ev.pageY=cY,delete s.pX,delete s.pY,cfg.over.apply($el[0],[ev]);s.pX=cX,s.pY=cY,s.timeoutId=setTimeout(function(){compare(ev,$el,s,cfg)},cfg.interval)};$.fn.hoverIntent=function(handlerIn,handlerOut,selector){var instanceId=INSTANCE_COUNT++,cfg=$.extend({},_cfg);$.isPlainObject(handlerIn)?(cfg=$.extend(cfg,handlerIn),$.isFunction(cfg.out)||(cfg.out=cfg.over)):cfg=$.isFunction(handlerOut)?$.extend(cfg,{over:handlerIn,out:handlerOut,selector:selector}):$.extend(cfg,{over:handlerIn,out:handlerIn,selector:handlerOut});function handleHover(e){var ev=$.extend({},e),$el=$(this),hoverIntentData=$el.data("hoverIntent");hoverIntentData||$el.data("hoverIntent",hoverIntentData={});var state=hoverIntentData[instanceId];state||(hoverIntentData[instanceId]=state={id:instanceId}),state.timeoutId&&(state.timeoutId=clearTimeout(state.timeoutId));var mousemove=state.event="mousemove.hoverIntent.hoverIntent"+instanceId;if("mouseenter"===e.type){if(state.isActive)return;state.pX=ev.pageX,state.pY=ev.pageY,$el.off(mousemove,track).on(mousemove,track),state.timeoutId=setTimeout(function(){compare(ev,$el,state,cfg)},cfg.interval)}else{if(!state.isActive)return;$el.off(mousemove,track),state.timeoutId=setTimeout(function(){!function(ev,$el,s,out){var data=$el.data("hoverIntent");data&&delete data[s.id],out.apply($el[0],[ev])}(ev,$el,state,cfg.out)},cfg.timeout)}}return this.on({"mouseenter.hoverIntent":handleHover,"mouseleave.hoverIntent":handleHover},cfg.selector)}});

// html controls
$('#nav-languages').before('<button id="nav-lang-open">More languages</button><button id="nav-lang-close" class="hidden">Fewer languages</button>');
$('.siteHeader__bar > .wrap').append('<button aria-controls="nav-site" aria-expanded="false" class="nav-site__button" title="Toggle navigation"><span class="hidden">Toggle navigation</span></button>');
$('.siteHeader__bar > .wrap').append('<button aria-controls="nav-site-search" aria-expanded="false" class="nav-site-search__button" title="Toggle search"><span class="hidden">Toggle search</span></button>');

var navToggle = $('.siteHeader__bar .nav-site__button');
var searchToggle = $('.siteHeader__bar .nav-site-search__button');

(function ($){

    //-------------------------------------------------
    // functions

    function siteHeaderLanguages() {

        $('#nav-lang-list li').remove();
        $('#nav-languages > ul > li').removeClass('hidden');
        $('#nav-languages').hide();
        $('#nav-lang-open').removeClass('hidden');
        $('#nav-lang-close').addClass('hidden');

        if ($(window).width() > 1300) {
            $('#nav-languages > ul > li:nth-child(1)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-languages > ul > li:nth-child(2)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-languages > ul > li:nth-child(3)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-languages > ul > li:nth-child(4)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-languages > ul > li:nth-child(5)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-languages > ul > li:nth-child(6)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-languages > ul > li:nth-child(7)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-languages > ul > li:nth-child(8)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-lang-list li').removeClass('hidden');
        }
        else if ($(window).width() > 840) {
            $('#nav-languages > ul > li:nth-child(1)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-languages > ul > li:nth-child(2)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-languages > ul > li:nth-child(3)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-languages > ul > li:nth-child(4)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-languages > ul > li:nth-child(5)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-lang-list li').removeClass('hidden');
        }
        else if ($(window).width() > 580) {
            $('#nav-languages > ul > li:nth-child(1)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-languages > ul > li:nth-child(2)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-languages > ul > li:nth-child(3)').addClass('hidden').clone().appendTo('#nav-lang-list');
            $('#nav-lang-list li').removeClass('hidden');
        }

        $('#nav-lang-open').on('click', function(){
            $('#nav-languages').slideDown();
            $('#nav-lang-open').addClass('hidden');
            $('#nav-lang-close').removeClass('hidden');
        });
        $('#nav-lang-close').on('click', function(){
            $('#nav-languages').slideUp();
            $('#nav-lang-open').removeClass('hidden');
            $('#nav-lang-close').addClass('hidden');
        });

    }


    function siteNav() {
        if ($(window).width() < 1000) {
            $('#nav-site').hide();
            $('#nav-site-search').hide();
            navToggle.show();
            searchToggle.hide();
        } else {
            $('#nav-site').show();
            $('#nav-site-search').hide();
            navToggle.hide();
            searchToggle.show();
        }
        if ($(window).width() > 1360) {
            $('#nav-site').show();
            $('#nav-site-search').show();
            navToggle.hide();
            searchToggle.hide();
        }
    }
    function siteNavActions() {

        navToggle.on('click', function() {
            if ( $('#nav-site').is(":visible") ) {
                $('#nav-site').hide();
                $('#nav-site-search').hide();
                $('.nav-site__button').attr( "aria-expanded", "false" );
            }
            else {
                $('#nav-site').show();
                $('#nav-site-search').show();
                $('.nav-site__button').attr( "aria-expanded", "true" );

            }

        });

        searchToggle.on('click', function() {
            if ( $('#nav-site-search').is(":visible") ) {
                $('#nav-site').show();
                $('#nav-site-search').hide();
                $('.nav-site-search__button').attr( "aria-expanded", "false" );

            } else {
                $('#nav-site').show();
                $('#nav-site-search').show();
                $('.nav-site-search__button').attr( "aria-expanded", "true" );
            }
        });
    }

    function siteNavDetails() {
        $("details summary", "#nav-site").on("click", function () {
            var details = $(this).parent();
            if ($(window).width() > 1) {
                $("details", "#nav-site").not(details).removeAttr("open");
                $("details summary", "#nav-site").not(this).attr("aria-expanded", "false");
            }
            if ( details.attr('open') ) {
                $(this).attr("aria-expanded", "false");
            } else {
                $(this).attr("aria-expanded", "true");
            }
        });

        $("details", ".nav-site__list").each(function () {
            var details = $(this);
            var dd = $('.primaryNav__secondLevel', this);
            dd.append('<button class="hs-nav-dropdown-close" aria-label="Close this section"><span>Close</span></button>');
            $('.hs-nav-dropdown-close', this).on("click", function () {
                $("summary", details).attr("aria-expanded", "false");
                details.removeAttr("open");
            });
        });
        $('.primaryNav__thirdLevelList').each(function(){
            var thirdLevel = $(this);
            thirdLevel.slideUp();
            var secondLevel = $(this).parent();
            secondLevel.prepend('<button class="thirdLevel-toggle" aria-label="Toggle menu"><span>Toggle menu</span></button>');
            $('.thirdLevel-toggle', secondLevel).on("click", function () {
                thirdLevel.slideToggle();
                $(this).toggleClass('open');
            });

        });
    }



    //-------------------------------------------------
    // execute

    $(document).ready(function () {
        siteHeaderLanguages();
        siteNav();
        siteNavActions();
        siteNavDetails();
    });


    var resizeId;
    $(window).resize(function() {
        clearTimeout(resizeId);
        resizeId = setTimeout(resizedEnded, 500);
    });
    function resizedEnded(){
        siteHeaderLanguages();
        siteNav();
    }

})(jQuery);
